import React, { useEffect } from 'react'
import { useOktaAuth } from '@okta/okta-react'
import { Alert, AlertDescription } from '@/components/ui/alert'

const SingleSignOn: React.FC = () => {
  const { oktaAuth } = useOktaAuth()

  useEffect(() => {
    const handleSSO = async () => {
      await oktaAuth.signInWithRedirect({ originalUri: '/' })
    }
    handleSSO()
  }, [oktaAuth])

  return (
    <div>
      <Alert variant="default">
        <AlertDescription>Authenticating...</AlertDescription>
      </Alert>
    </div>
  )
}

export default SingleSignOn
